angular.module('cvsApp').service('manageFavoriteStoresService',['networkService', 'xdrService', 'configManager', 'cvsAppData','favStoreInfoModel', function (NS, XS,CM,CAD,FSIM) {
   	
	function manageFavoriteStoresService (){
		this.addFavoriteStore = function(callBackSuccess,guestTokenID,actionType,storeId){
			//get url

			var tokenId, tokenType;
			/*var tokenId=CAD.getTokenId();
			 var tokenType=CAD.getTokenType();*/
			try{
				tokenId = CAD.getTokenId() ? CAD.getTokenId() : (guestTokenID || cvsUtility.queryMap.tokenId);
				tokenType = CAD.getTokenType() ? CAD.getTokenType() : ((guestTokenID) ? 'Guest' : 'Login');
			}
			catch(ex){
				tokenId = guestTokenID || cvsUtility.queryMap.tokenId;
				tokenType = (guestTokenID) ? 'Guest' : 'Login';
			}
			var url = CM.getAPIUrlWithActionInfo('MANAGE_FAVORITE_STORE', tokenId, tokenType,actionType,storeId);
			if(url === "URL_ERROR"){

			}else{
				var plainUrl = CM.getPlainApiUrl(url);
				var request = {url:plainUrl,
							header:{"Content-Type":"application/json", "accept": "application/xml"},
							data:getRequestBody(url),
							onSuccess:callBackSuccess
						}
			
				cvsUtility.commonServiceCode(plainUrl,"manageFavoriteStores",FSIM,request,callBackSuccess,NS);	
			}
						
		}


		var getRequestBody = function(entities){
			var requestJson = { serviceParams: CM.getModifiedParams(entities) };
			return requestJson;
		}
	
	}
	
	return new manageFavoriteStoresService();	
}]);

